import React, { Suspense, useState } from 'react';
import { IOrder } from '@/interfaces/order';
import { Button, Col, Row } from 'antd';
import Title from '@/components/title';
import { PrinterOutlined } from '@ant-design/icons';
import { IDataModal } from '@/interfaces/dataModal';
import PrintModal from '@/components/templates/print-delivery-modal';

interface IProps {
  data: IOrder;
}

const _printModal: IDataModal<IOrder> = {
  open: false,
};

const DeliveryDocPrint = ({ data }: IProps) => {
  const [print, setPrint] = useState<IDataModal<IOrder>>({
    ..._printModal,
  });
  return (
    <Row gutter={12} className="">
      <Col span={24}>
        <div className="border-2 border-dashed border-red-700 rounded-md px-3 bg-red-100">
          <Title title="เอกสาร บันทึกกำรตรวจสภำพรถบรรทุกขนส่งวัตถุดิบและสารเสริม">
            <div className="flex flex-row gap-2">
              <Button
                type="primary"
                ghost
                onClick={() =>
                  setPrint({ open: true, item: data, optional: 'template' })
                }
              >
                <PrinterOutlined />
                พิมพ์ Template
              </Button>
              <Button
                type="primary"
                onClick={() =>
                  setPrint({ open: true, item: data, optional: 'data' })
                }
              >
                <PrinterOutlined />
                พิมพ์เอกสาร
              </Button>
            </div>
          </Title>
        </div>
      </Col>
      <Suspense>
        <PrintModal
          open={print.open}
          handleCancel={function (): void {
            setPrint({
              ..._printModal,
            });
          }}
          order={print.item}
          isTempalte={print.optional === 'template'}
        />
      </Suspense>
    </Row>
  );
};

export default DeliveryDocPrint;
